/* eslint-disable indent */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Input,
  NativeSelect,
  Paper,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { dddTel, formatDateTimeToRender } from '../../../../utils/functions';
import { TOKEN_USER } from '../../../../services/auth';
import PhoneMask from '../../../Collaborator/components/PhoneMask';
import { capitalizeFirstLetter } from '../../../../utils/functions';
import useStyles from '../style';
import { useLocation } from "react-router";
import ReactInputMask from 'react-input-mask';

const MODO_ENVIO_OPTIONS = [
  { id: 1, texto: 'WhatsApp', nome: 'whatsapp' },
  { id: 2, texto: 'E-mail', nome: 'email' },
];

const normalizeModoEnvio = (value = '') => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (typeof value === 'number') {
    const found = MODO_ENVIO_OPTIONS.find((item) => item.id === value);
    return found ? found.nome : '';
  }

  const normalized = String(value).trim().toLowerCase();
  if (normalized === '1') return 'whatsapp';
  if (normalized === '2') return 'email';

  const found = MODO_ENVIO_OPTIONS.find(
    (item) => item.nome === normalized || item.texto.toLowerCase() === normalized,
  );
  return found ? found.nome : normalized;
};

const modoEnvioToId = (value) => {
  const normalized = normalizeModoEnvio(value);
  const found = MODO_ENVIO_OPTIONS.find((item) => item.nome === normalized);
  return found ? found.id : null;
};

export function ContactGroupAssRegister() {
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const isMountedRef = useRef(true);
  const classes = useStyles();
  const { id, idGrupoContatoAss } = useParams();
  
  // Debug logs
  console.log('Component mounted - useParams:', { id, idGrupoContatoAss });
  console.log('Current pathname:', window.location.pathname);

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [autenticacaoOpcoes, setAutenticacaoOpcoes] = useState([]);
  const [qualificacaoOpcoes, setQualificacaoOpcoes] = useState([]);

  const [getErros, setErros] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState();
  const [provider, setProvider] = useState();

  const { state } = useLocation();
  console.log('useLocation state:', state);
  const contatoId = idGrupoContatoAss || state?.fornecedorContatoAssinaturaId;
  console.log('Derived contatoId:', contatoId);

  const hoje = new Date()
    .toISOString()
    .slice(0, -1);

  const [inputs, setInputs] = useState({
    autenticacao1: "",
    autenticacao2: "",
    cpf: "",
    dataNascimento: "",
    ddd: "",
    email: "",
    nome: "",
    qualificacao: "",
    modoEnvio: "",
    status: "Ativo",
    telefone: "",
    dataAtualizacao: hoje,
  });

  const [formValues, setformValues] = useState({
    autenticacao1: "",
    autenticacao2: "",
    cpf: "",
    dataNascimento: "",
    ddd: "",
    email: "",
    nome: "",
    qualificacao: "",
    modoEnvio: "",
    status: "Ativo",
    telefone: "",
    dataAtualizacao: hoje,
  });

  const handleInputChange = (event) => {
    event.persist();
    const { name, value } = event.target;
    
    setformValues((inputs) => ({ ...inputs, [name]: value }));
  };


  const fetchContactById = async (contactId) => {
    if (!contactId) return;
    setLoading(true);
    try {
      // Use contatoId derived from route or state
      const idToUse = contactId?.fornecedorContatoAssinaturaId || contactId;
      console.log('Fetching contact from FornecedoresContatosAssinaturas with ID:', idToUse);
      
      console.log('Making API call to:', `FornecedoresContatosAssinaturas/ConsultarId?id=${idToUse}`);
      const res = await api.get(`FornecedoresContatosAssinaturas/ConsultarId?id=${idToUse}`);
      console.log('Contact data response from FornecedoresContatosAssinaturas:', res.data);
      console.log('Full response object:', res);
      
      if (res.data.resposta) {
        const contato = res.data.resposta;

        setInputs({
          ...contato,
          telefone: contato.telefone && `(${contato.ddd}) ${contato.telefone}`,
        });
        
        // Map backend string enum names (e.g., "whatsapp", "administrator") -> option ids
        const toIdByNome = (lista, nome) => {
          if (!nome) return '';
          const item = lista.find(x => (x.Nome || x.nome) === String(nome).toLowerCase());
          return item ? String(item.Id || item.id) : '';
        };

        const formData = {
          ...contato,
          dataNascimento: isoToBr(contato.dataNascimento || contato.DataNascimento),
          telefone: (contato.telefone || contato.Telefone) && `(${contato.ddd || contato.Ddd}) ${contato.telefone || contato.Telefone}`,
          // Use enum names (lowercase) directly for selects
          autenticacao1: String((contato.autenticacao1 ?? contato.Autenticacao1 ?? '')).toLowerCase(),
          autenticacao2: String((contato.autenticacao2 ?? contato.Autenticacao2 ?? '')).toLowerCase(),
          qualificacao: String((contato.qualificacao ?? contato.Qualificacao ?? '')).toLowerCase(),
          modoEnvio: normalizeModoEnvio(contato.modoEnvio ?? contato.ModoEnvio ?? ''),
        };
        
        console.log('Setting form values:', formData);
        console.log('Autenticacao1 value:', formData.autenticacao1);
        console.log('Autenticacao2 value:', formData.autenticacao2);
        console.log('Qualificacao value:', formData.qualificacao);
        
        setformValues(formData);

        setSelectedGroup((prev) => ({
          ...prev,
          idGrupoContato: contato.fornecedorContatoAssinaturaId
        }));
      } else {
        console.error('No contact data found in response from FornecedoresContatosAssinaturas');
      }

    } catch (error) {
      console.log('Error fetching contact from FornecedoresContatosAssinaturas:', error);
      if (error?.response?.data?.resposta?.[0]) {
        toast.error(error.response.data.resposta[0].message);
      } else {
        toast.error('Erro ao carregar dados do contato');
      }
    }
    setLoading(false);
  };

  const getInfoForForm = async () => {
    setLoading(true);
    try {
      const findCargos = await api.get('Cargos/Consultar?status=Ativo');
      setCargos(findCargos.data.resposta);
    } catch (err) {
      if (err?.response?.data?.resposta?.[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  const updateContact = async (payload) => {
   
    const formatarData = (dataBr) => {
      if (!dataBr) return null;
      const [dia, mes, ano] = dataBr.split('/');
      // retorna com hora e milissegundos
      return `${ano}-${mes}-${dia}T10:18:01.703`; // exemplo fixo
    };


    const payloadUpadte = {
      ...inputs,
      ...payload,
      // Email já vem lowercase do onSubmit, mas garantimos novamente
      email: (payload.email || "").toLowerCase().trim(),
      dataNascimento: formatarData(payload.dataNascimento),
      // preserve original dataAtualizacao to avoid concurrency error
      dataAtualizacao: inputs?.dataAtualizacao, // Use original dataAtualizacao from GET
    };
    
    console.log('Payload formatado para atualizar contato:', payloadUpadte);
    
    try {
      const response = await api.put('FornecedoresContatosAssinaturas', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Contato alterado com sucesso!');
        setInputs(response.data.resposta);
        // setformValues({}); 
      } else {
        // Mostra erros mais específicos
        const erros = handleErrorRequest(response);
        setErros(erros);
        
        // Tenta mostrar mensagem específica do erro
        if (response.data?.resposta?.[0]?.message) {
          toast.error(`Erro ao atualizar: ${response.data.resposta[0].message}`);
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar contato:', error);
      const erros = handleErrorRequest(error.response);
      setErros(erros);
      
      // Mostra mensagem de erro mais específica
      if (error.response?.data?.resposta?.[0]?.message) {
        toast.error(`Erro ao atualizar: ${error.response.data.resposta[0].message}`);
      } else if (error.message) {
        toast.error(`Erro ao atualizar contato: ${error.message}`);
      }
    }
  };

  const isoToBr = (isoDate) => {
  if (!isoDate) return "";
  const d = new Date(isoDate);
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const ano = d.getFullYear();
  return `${dia}/${mes}/${ano}`;
};


  const createContact = async (payload) => {
   
    try {
      const formatarData = (dataBr) => {
        if (!dataBr) return null;
        const [dia, mes, ano] = dataBr.split('/');
        return `${ano}-${mes}-${dia}T10:18:01.703`; // exemplo fixo
      };


      const payloadFormatado = {
        ...payload,
        // Email já vem lowercase do onSubmit, mas garantimos novamente
        email: (payload.email || "").toLowerCase().trim(),
        dataNascimento: formatarData(payload.dataNascimento),
        dataRegistro: hoje,
      };

      console.log('Payload formatado para criar contato:', payloadFormatado);

      const response = await api.post('FornecedoresContatosAssinaturas', payloadFormatado);

      if (response.data.status !== 'Inconsistencia') {
        toast.success('Contato criado com sucesso!');
        setformValues({
          autenticacao1: "",
          autenticacao2: "",
          cpf: "",
          dataNascimento: "",
          ddd: "",
          email: "",
          nome: "",
          qualificacao: "",
          modoEnvio: "",
          status: "Ativo",
          telefone: "",
          dataAtualizacao: hoje,
        });
        setInputs({
          autenticacao1: "",
          autenticacao2: "",
          cpf: "",
          dataNascimento: "",
          ddd: "",
          email: "",
          nome: "",
          qualificacao: "",
          modoEnvio: "",
          status: "Ativo",
          telefone: "",
          dataAtualizacao: hoje,
        });

      } else {
        // Mostra erros mais específicos
        const erros = handleErrorRequest(response);
        setErros(erros);
        
        // Tenta mostrar mensagem específica do erro
        if (response.data?.resposta?.[0]?.message) {
          toast.error(`Erro ao criar: ${response.data.resposta[0].message}`);
        }
      }
    } catch (error) {
      console.error('Erro ao criar contato:', error);
      const erros = handleErrorRequest(error.response);
      setErros(erros);
      
      // Mostra mensagem de erro mais específica
      if (error.response?.data?.resposta?.[0]?.message) {
        toast.error(`Erro ao criar: ${error.response.data.resposta[0].message}`);
      } else if (error.message) {
        toast.error(`Erro ao criar contato: ${error.message}`);
      }
    }
  };


  const onSubmit = async () => {
    // Validações básicas

    // Map status to numeric enum required by backend (Ativo=1, Inativo=0)
    const statusNumber = (() => {
      const s = (formValues.status || inputs?.status || '').toString().toLowerCase();
      if (s === 'ativo' || s === '1') return 1;
      if (s === 'inativo' || s === '0') return 0;
      return 1; // default to Ativo
    })();

    // Convert selected names back to IDs using options lists
    const getAutenticacaoId = (value) => {
      if (!value || value === "") return null; // Return null for empty values
      const v = value.toString().toLowerCase();
      const found = autenticacaoOpcoes.find(x => (x.nome || x.texto || '').toLowerCase() === v);
      return found ? Number(found.id) : null;
    };

    const getQualificacaoId = (value) => {
      if (!value || value === "") return null; // Return null for empty values
      const v = value.toString().toLowerCase();
      const found = qualificacaoOpcoes.find(x => (x.nome || x.texto || '').toLowerCase() === v);
      return found ? Number(found.id) : null;
    };

    const payload = {
      ...formValues,
      // Email sempre em lowercase
      email: (formValues.email || "").toLowerCase().trim(),
      // Telefone e DDD
      ...(formValues.telefone && { ddd: dddTel(formValues.telefone, 'ddd') }),
      ...(formValues.telefone && { telefone: dddTel(formValues.telefone) }),
      // IDs numéricos obrigatórios
      fornecedorId: Number(provider.fornecedorId ?? provider.id),
      // Autenticações e Qualificação - envia null se vazio
      autenticacao1: getAutenticacaoId(formValues.autenticacao1),
      autenticacao2: getAutenticacaoId(formValues.autenticacao2),
      qualificacao: getQualificacaoId(formValues.qualificacao),
      modoEnvio: modoEnvioToId(formValues.modoEnvio),
      // Status as numeric enum
      status: statusNumber,
      // Ensure optimistic concurrency field goes with update - use original dateAtualizacao from GET
      dataAtualizacao: inputs?.dataAtualizacao // Use original dateAtualizacao from GET, not current time
    };

    // Limpa DDD se não tiver telefone
    if (!payload.telefone) {
      payload.ddd = '';
    }

    console.log('Payload antes de enviar:', payload);

    isRegister ? createContact(payload) : updateContact(payload);
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    setProvider(res.data.resposta);
  };


  const fetchAutenticacaoTipos = async () => {
    try {
      const response = await api.get('FornecedoresContatosAssinaturas/AutenticacaoTipos');
      console.log('AutenticacaoTipos response:', response.data);
      // API returns direct array, not wrapped in resposta
      const itensRaw = Array.isArray(response.data) ? response.data : response?.data?.resposta;
      // Normalize to have id, texto, nome(lowercase)
      const itens = (itensRaw || []).map(x => ({
        id: x.Id ?? x.id,
        texto: x.Texto ?? x.texto,
        nome: (x.Nome ?? x.nome ?? (x.Texto ?? x.texto)).toString().toLowerCase()
      }));
      if (Array.isArray(itens) && itens.length > 0) {
        console.log('Setting autenticacao options:', itens);
        setAutenticacaoOpcoes(itens);
      } else {
        console.log('No autenticacao options found');
        setAutenticacaoOpcoes([]);
      }
    } catch (err) {
      console.log('Error fetching autenticacao tipos:', err);
      if (err?.response?.data?.resposta?.[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Erro ao carregar tipos de autenticação');
      }
    }
  }

  const fetchQualificacaoTipos = async () => {
    try {
      const response = await api.get('FornecedoresContatosAssinaturas/QualificacaoTipos');
      console.log('QualificacaoTipos response:', response.data);
      // API returns direct array, not wrapped in resposta
      const itensRaw = Array.isArray(response.data) ? response.data : response?.data?.resposta;
      const itens = (itensRaw || []).map(x => ({
        id: x.Id ?? x.id,
        texto: x.Texto ?? x.texto,
        nome: (x.Nome ?? x.nome ?? (x.Texto ?? x.texto)).toString().toLowerCase()
      }));
      if (Array.isArray(itens) && itens.length > 0) {
        console.log('Setting qualificacao options:', itens);
        setQualificacaoOpcoes(itens);
      } else {
        console.log('No qualificacao options found');
        setQualificacaoOpcoes([]);
      }
    } catch (err) {
      console.log('Error fetching qualificacao tipos:', err);
      if (err?.response?.data?.resposta?.[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Erro ao carregar tipos de qualificação');
      }
    }
  }

  // Main useEffect - Initialize component
  useEffect(() => {
    console.log('=== MAIN useEffect triggered ===');
    console.log('idGrupoContatoAss:', idGrupoContatoAss);
    console.log('id (fornecedorId):', id);
    console.log('state:', state);
    console.log('window.location.pathname:', window.location.pathname);
    
    const initializeComponent = async () => {
      try {
        // Load initial data
        getInfoForForm();
        fetchProvider();
        
        // Load dropdown data
        console.log('Loading dropdown data...');
        await Promise.all([
          fetchAutenticacaoTipos(),
          fetchQualificacaoTipos()
        ]);
        console.log('Dropdown data loaded successfully');
        
        // Check mode
        if (window.location.pathname.includes('cadastrar')) {
          console.log('MODE: cadastrar');
          setLoading(false);
          setIsEditing(true);
          setIsRegister(true);
        } else if (window.location.pathname.includes('editar')) {
          console.log('MODE: editar');
          setIsEditing(true);
          setIsRegister(false);
          
          // Load contact data for edit mode
          if (contatoId) {
            console.log('✅ Loading contact data with ID:', contatoId);
            console.log('Making API call to: FornecedoresContatosAssinaturas/ConsultarId?id=' + contatoId);
            await fetchContactById(contatoId);
          } else {
            console.log('❌ contatoId is missing, cannot load contact data');
          }
        } else {
          console.log('MODE: view');
          setIsEditing(false);
          setIsRegister(false);
          
          // Load contact data for view mode
          if (contatoId) {
            console.log('Loading contact data for view with ID:', contatoId);
            await fetchContactById(contatoId);
          } else if (state) {
            console.log('Loading contact data from state:', state);
            await fetchContactById(state);
          }
        }
      } catch (error) {
        console.error("Error initializing component:", error);
      }
    };

    initializeComponent();

    // Cleanup function
    return () => {
      isMountedRef.current = false;
    };
  }, []);  // Run only once on mount

  useEffect(() => {
    setSelectedGroup((input) => ({ ...input, tipoPessoa: inputs?.tipoPessoa }));
  }, [inputs?.tipoPessoa]);


  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} contato do fornecedor - ${provider?.nomeFantasia ?? ''
            }`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando contato do fornecedor - ${provider?.nomeFantasia ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <form onSubmit={onSubmit}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          autoFocus
                          style={{ padding: 0 }}
                          className={classes.input}
                          placeholder="Nome"
                          value={formValues.nome}
                          name="nome"
                          disabled={!isEditing && !isRegister}
                          classes={{ input: classes.input }}
                          onBlur={(event) =>
                            getErros.includes('Nome') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Nome';
                              }),
                            )
                          }
                          error={getErros.includes('Nome')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>CPF</label>
                      <Paper className={classes.medium} elevation={0}>

                        <ReactInputMask
                          mask="999.999.999-99"
                          value={formValues.cpf}
                          name="cpf"
                          disabled={!isEditing && !isRegister}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('cpf') &&
                            setErros(getErros.filter((item) => item !== 'cpf'))
                          }
                        >
                          {(inputProps) => (
                            <Input
                              {...inputProps}
                              autoFocus
                              style={{ padding: 0 }}
                              className={classes.input}
                              placeholder="CPF"
                              error={getErros.includes('cpf')}
                              inputProps={{
                                ...inputProps, // garante que o mask funcione
                                minLength: 3,
                                maxLength: 100,
                                style: { paddingLeft: 8, paddingTop: 5 }, // <--- aqui você ajusta

                              }}
                            />
                          )}
                        </ReactInputMask>

                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Data de nascimento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <ReactInputMask
                          mask="99/99/9999"
                          value={formValues.dataNascimento}
                          name="dataNascimento"
                          disabled={!isEditing && !isRegister}
                          onBlur={(event) =>
                            getErros.includes('dataNascimento') &&
                            setErros(
                              getErros.filter((item) => item !== 'dataNascimento')
                            )
                          }
                          onChange={handleInputChange}
                          autoComplete="off"
                        >
                          {(inputProps) => (
                            <Input
                              {...inputProps}
                              inputRef={inputProps.ref} // ESSENCIAL para não travar a tela
                              autoFocus
                              style={{ padding: 0 }}
                              className={classes.input}
                              placeholder="Data de nascimento"
                              error={getErros.includes('dataNascimento')}
                              classes={{ input: classes.input }}
                              inputProps={{
                                minLength: 3,
                                maxLength: 100,
                              }}
                            />
                          )}
                        </ReactInputMask>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={!isEditing}
                          className={classes.input}
                          value={formValues.status || inputs?.status}
                          name="status"
                          onChange={handleInputChange}
                          error={getErros.includes('Status')}
                          onBlur={(event) =>
                            getErros.includes('Status') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Status';
                              }),
                            )
                          }
                        >
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Modo de envio</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={normalizeModoEnvio(formValues.modoEnvio)}
                          name="modoEnvio"
                          disabled={!isEditing && !isRegister}
                          onChange={handleInputChange}
                          error={getErros.includes('modoEnvio')}
                          onBlur={(event) =>
                            getErros.includes('modoEnvio') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'modoEnvio';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione o modo de envio</option>
                          {MODO_ENVIO_OPTIONS.map((modoEnvio) => (
                            <option key={modoEnvio.id} value={modoEnvio.nome}>
                              {modoEnvio.texto}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          placeholder="E-mail"
                          type="email"
                          value={formValues.email}
                          name="email"
                          disabled={!isEditing && !isRegister}
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('Email') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Email';
                              }),
                            )
                          }
                          error={getErros.includes('Email')}
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>



                    <Grid item xs={6}>
                      <label className={classes.label}>Autenticação 1</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={(formValues.autenticacao1 ?? '').toString().toLowerCase()}
                          name="autenticacao1"
                          disabled={!isEditing && !isRegister}
                          onChange={handleInputChange}
                          error={getErros.includes('autenticacao1')}
                          onBlur={(event) =>
                            getErros.includes('autenticacao1') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'autenticacao1';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione uma autenticação</option>
                          {autenticacaoOpcoes.map((autenticacao) => (
                            <option key={autenticacao.id}
                              value={(autenticacao.nome || autenticacao.texto || '').toString().toLowerCase()}>
                              {autenticacao.texto}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Autenticação 2</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={(formValues.autenticacao2 ?? '').toString().toLowerCase()}
                          name="autenticacao2"
                          disabled={!isEditing && !isRegister}
                          onChange={handleInputChange}
                          error={getErros.includes('autenticacao2')}
                          onBlur={(event) =>
                            getErros.includes('autenticacao2') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'autenticacao2';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione uma autenticação</option>
                          {autenticacaoOpcoes.map((autenticacao) => (
                            <option key={autenticacao.id}
                              value={(autenticacao.nome || autenticacao.texto || '').toString().toLowerCase()}>
                              {autenticacao.texto}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Qualificação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={(formValues.qualificacao ?? '').toString().toLowerCase()}
                          name="qualificacao"
                          disabled={!isEditing && !isRegister}
                          onChange={handleInputChange}
                          error={getErros.includes('qualificacao')}
                          onBlur={(event) =>
                            getErros.includes('qualificacao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'qualificacao';
                              }),
                            )
                          }
                        >
                          <option value="">Selecione uma qualificação</option>
                          {qualificacaoOpcoes.map((qualificacao) => (
                            <option key={qualificacao.id}
                              value={(qualificacao.nome || qualificacao.texto || '').toString().toLowerCase()}>
                              {qualificacao.texto}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Telefone</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={formValues.telefone}
                          name="telefone"
                          isDisabled={!isEditing && !isRegister}
                          autocomplete="off"
                          error={getErros.includes('Telefone')}
                          onBlur={(event) =>
                            getErros.includes('Telefone') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Telefone';
                              }),
                            )
                          }
                          className={classes.input}
                          placeholder="Telefone"
                          onChange={handleInputChange}
                          inputProps={{
                            minLength: 2,
                            maxLength: 20,
                          }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              {!isRegister && (
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={classes.summary}
                  >
                    <Typography className={classes.heading}>Dados do Registro</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Data de Registro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)
                            }
                            readOnly
                            disabled={!isEditing}
                            placeholder="Data do Registro"
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Data da Atualização</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={
                              inputs.dataAtualizacao
                                ? formatDateTimeToRender(inputs.dataAtualizacao)
                                : ''
                            }
                            readOnly
                            disabled={!isEditing}
                            placeholder="Data da Atualização"
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}
              {(isRegister || isEditing) && (
                <div className={classes.divButton}>
                  <button
                    variant="contained"
                    type="button"
                    onClick={onSubmit}
                    className={classes.button}
                  >
                    {isRegister ? 'Cadastrar' : 'Atualizar'}
                  </button>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
